<template>
  <div class="elite-tabs-wrapper-content">
    <div class="row mb-4">
      <h3 class="display-4 col-12">{{ $t("COMMON.DETAILS") }}</h3>
    </div>

    <purchases-delivery-view-details-purchases-delivery-item-list
      :purchasesDelivery="purchasesDelivery"
      @purchasesDeliveryItemsUpdated="purchasesDeliveryItemsUpdated"
    />
  </div>
</template>

<script>
import { Button, Tooltip } from "element-ui";
import PurchasesDeliveryViewDetailsPurchasesDeliveryItemList from "./PurchasesDeliveryViewDetailsPurchasesDeliveryItemList.vue";

export default {
  name: "purchases-delivery-view-details",

  components: {
    PurchasesDeliveryViewDetailsPurchasesDeliveryItemList,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
  },

  mixins: [],

  props: ["purchasesDelivery"],

  data() {
    return {};
  },

  computed: {},

  methods: {
    purchasesDeliveryItemsUpdated() {
      this.$emit("purchasesDeliveryItemsUpdated");
    },
  },

  mounted() {},

  watch: {},
};
</script>
